import { useEffect } from 'react'

export type ToastType = 'success' | 'error' | 'warning' | 'info'

export interface ToastItem {
  id: string
  type: ToastType
  message: string
  duration?: number
  onClick?: () => void
}

interface Props {
  toasts: ToastItem[]
  onRemove: (id: string) => void
}

const ICONS = { success:'✅', error:'❌', warning:'⚠️', info:'ℹ️' }
const COLORS = {
  success: { bg:'#14532d', border:'#22c55e', text:'#4ade80' },
  error:   { bg:'#450a0a', border:'#ef4444', text:'#f87171' },
  warning: { bg:'#451a03', border:'#fbbf24', text:'#fcd34d' },
  info:    { bg:'#0c2a4a', border:'#0ea5e9', text:'#38bdf8' },
}

export default function Toast({ toasts, onRemove }: Props) {
  useEffect(() => {
    toasts.forEach(t => {
      const timer = setTimeout(() => onRemove(t.id), t.duration ?? 4000)
      return () => clearTimeout(timer)
    })
  }, [toasts, onRemove])

  if (!toasts.length) return null

  return (
    <div style={{ position:'fixed', bottom:24, right:24, zIndex:9999,
      display:'flex', flexDirection:'column', gap:8, maxWidth:360 }}>
      {toasts.map(t => {
        const c = COLORS[t.type]
        return (
          <div key={t.id} onClick={t.onClick}
            style={{ background:c.bg, border:`1px solid ${c.border}`,
            borderRadius:10, padding:'12px 16px', display:'flex', alignItems:'center',
            gap:10, boxShadow:'0 4px 20px rgba(0,0,0,0.4)', cursor: t.onClick ? 'pointer' : 'default',
            animation:'slideIn 0.2s ease', fontFamily:'Inter,sans-serif' }}>
            <span style={{ fontSize:18 }}>{ICONS[t.type]}</span>
            <span style={{ flex:1, fontSize:13, color:c.text, fontWeight:500 }}>{t.message}</span>
            <button onClick={() => onRemove(t.id)}
              style={{ background:'none', border:'none', color:c.text, cursor:'pointer',
                fontSize:16, padding:'0 2px', opacity:0.7 }}>✕</button>
          </div>
        )
      })}
      <style>{`@keyframes slideIn{from{opacity:0;transform:translateX(40px)}to{opacity:1;transform:translateX(0)}}`}</style>
    </div>
  )
}
